import React, { useCallback } from 'react';

import styled from 'styled-components';
import NotiItem from './NotiItem';
import firebase from 'firebase/compat/app';
import SeeMoreBtn from '@components/dataEntry/button/SeeMoreBtn/SeeMoreBtn';
import { infinitePaginate } from '@store/firebase/infinitePaginate';

const Empty = styled.div`
  padding: 32px 8px;
  color: var(--subTextColor);
  font-size: 13px;
  text-align: center;
`;

type Props = {
  list: any;
  limit: number;
  mutate: any;
  collectionPath: string;
  where?: [string, firebase.firestore.WhereFilterOp, any];
};

function NotiList({ list, limit, mutate, collectionPath, where }: Props) {
  if (!list || list.length < 1) return <Empty>알림이 없습니다.</Empty>;

  const handlePaginate = useCallback(() => {
    infinitePaginate({
      list,
      collectionPath,
      limit,
      mutate,
      where,
    });
  }, [list, limit, mutate, collectionPath, where]);

  return (
    <>
      {list &&
        list.map((item) => {
          return <NotiItem key={item.id} data={item} />;
        })}
      <SeeMoreBtn onClick={handlePaginate} hidden={list.length < 8} />
    </>
  );
}

export default NotiList;
